import { isEqual } from 'lodash';

import type { DuplicateAdProps } from './DuplicateAd';

export function arePropsEqual(prev: DuplicateAdProps, next: DuplicateAdProps): boolean {
  const isDisabledEqual = prev.isDisabled === next.isDisabled;

  const prevLineItemIds = prev.selectedLineItems.map((item) => item.id);
  const nextLineItemIds = next.selectedLineItems.map((item) => item.id);

  const areSelectedLineItemsEqual = isEqual(prevLineItemIds, nextLineItemIds);

  const prevAdIds = prev.selectedAds.map((item) => item.id);
  const nextAdIds = next.selectedAds.map((item) => item.id);
  const areSelectedAdsEqual = isEqual(prevAdIds, nextAdIds);

  return isDisabledEqual && areSelectedAdsEqual && areSelectedLineItemsEqual;
}
